import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail.data.html.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (!newMediaGallery || !currentMediaGallery) return;

    const variantMediaId = event.detail.resource?.featured_media?.id;
    const mediaSelector = variantMediaId ? `[data-media-id="${variantMediaId}"]` : null;

    if (currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);

      // Le HTML renvoyé place le média de la variante en premier.
      // Attendre l'initialisation de Splide puis afficher explicitement ce média.
      requestAnimationFrame(() => {
        const slides = [...newMediaGallery.querySelectorAll('.product-media-gallery-main-slider .splide__slide')];
        const selectedSlide = mediaSelector ? newMediaGallery.querySelector(mediaSelector) : slides[0];
        const selectedIndex = Math.max(0, slides.indexOf(selectedSlide));

        newMediaGallery.slider?.go(selectedIndex);
        window.ShopifyXR?.setupXRElements();
      });
    } else if (mediaSelector) {
      const slides = [...currentMediaGallery.querySelectorAll('.product-media-gallery-main-slider .splide__slide')];
      const selectedSlide = currentMediaGallery.querySelector(mediaSelector);
      const selectedIndex = slides.indexOf(selectedSlide);

      if (selectedIndex >= 0) currentMediaGallery.slider?.go(selectedIndex);
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}
